var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cards-main__link blue-btn",attrs:{"href":_vm.finalUrl}},[_vm._v(_vm._s(_vm._f("trans")(_vm.finalText)))])}
var staticRenderFns = []

export { render, staticRenderFns }